<template>
  <div v-if="BUSY" id="spinner">
    <i class="fas fa-3x fa-spinner fa-spin"></i>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["BUSY"])
  }
};
</script>

<style scoped>
#spinner {
  position: fixed;

  top: 50%;
  left: 50%;

  width: 3em;
  height: 3em;
  margin-left: -4.5em;
  margin-top: -4.5em;

  padding: 3em;
  border-radius: 1em;

  background-color: lightgray;
  opacity: 0.8;

  z-index: 1000;
}
.fas {
  color: white;
}
</style>
